import { Component, OnInit } from '@angular/core';
import { ProductBasicDataService } from '../services/product-basic-data.service';
import { ProductService } from '../services/product.service';
import { EnumAba } from 'src/app/models/api/produto/aba.enum';
import { combineLatest, merge } from 'rxjs';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'c-product-basic-data',
  templateUrl: './product-basic-data.component.html',
  styleUrls: ['./product-basic-data.component.scss']
})
export class ProductBasicDataComponent implements OnInit {

  enumAba = EnumAba;

  eanTypes = [
    { value: 'EAN-8', label: 'EAN-8', mask: '00000000', maxLength: 8 },
    { value: 'EAN-12', label: 'EAN-12', mask: '000000000000', maxLength: 12 },
    { value: 'EAN-13', label: 'EAN-13', mask: '0000000000000', maxLength: 13 },
    { value: 'EAN-14', label: 'EAN-14', mask: '00000000000000', maxLength: 14 },
    { value: 'EAN-18', label: 'EAN-18', mask: '000000000000000000', maxLength: 18 }
  ];

  selectedEanType: any = null;
  eanMask: string = '';
  eanMaxLength: number = 0;
  isEanDisabled: boolean = true;
  eanPlaceholder: string = 'Selecione o tipo primeiro';

  constructor(
    public productBasicDataService: ProductBasicDataService,
    public productService: ProductService
  ) { }

  ngOnInit() {
    this.productBasicDataService.form.get("foraDaEmbalagem.pesoBruto").valueChanges.subscribe(v => {
      this.productBasicDataService.form.get("embalagemUnitaria.pesoLiquido").setValue(v);
    });
    const pesoBrutoUnitarioControl = this.productBasicDataService.form.get('embalagemUnitaria.pesoBruto')
    const embalagemMultiplaCaixaControl = this.productBasicDataService.form.get('embalagemCaixa.embalagemMultipla')
    merge(pesoBrutoUnitarioControl.valueChanges, embalagemMultiplaCaixaControl.valueChanges)
        .subscribe((v) => {
          const pesoBruto = pesoBrutoUnitarioControl.value;
          const unidade = embalagemMultiplaCaixaControl.value;
          if (pesoBruto && unidade){
            this.productBasicDataService.form.get("embalagemCaixa.pesoLiquido").setValue(parseFloat((pesoBruto * unidade).toFixed(3)));
          }
          else{
            this.productBasicDataService.form.get("embalagemCaixa.pesoLiquido").setValue(null);
          }
    })

    // Auto-select EAN type if EAN is already filled
    const eanControl = this.productBasicDataService.form.get('embalagemUnitaria.ean') as FormControl;
    if (eanControl && eanControl.value) {
      const value: string = eanControl.value;
      const eanDunRegex = /^(\d{8}|\d{12}|\d{13}|\d{14}|\d{18})$/;
      if (eanDunRegex.test(value)) {
        const matchedType = this.eanTypes.find(type => value.length === type.maxLength);
        if (matchedType) {
          this.selectedEanType = matchedType;
          this.eanMask = matchedType.mask;
          this.eanMaxLength = matchedType.maxLength;
          this.isEanDisabled = false;
          this.eanPlaceholder = `Digite o código ${matchedType.label}`;
          eanControl.enable();
        }
      } else {
        this.selectedEanType = null;
        this.eanMask = '';
        this.eanMaxLength = 0;
        this.isEanDisabled = true;
        this.eanPlaceholder = 'Selecione o tipo primeiro';
        eanControl.disable();
      }
    } else {
      this.selectedEanType = null;
      this.eanMask = '';
      this.eanMaxLength = 0;
      this.isEanDisabled = true;
      this.eanPlaceholder = 'Selecione o tipo primeiro';
      if (eanControl) eanControl.disable();
    }
  }

  onEanTypeChange(selectedType: any) {
    this.selectedEanType = selectedType;
    if (selectedType) {
      this.eanMask = selectedType.mask;
      this.eanMaxLength = selectedType.maxLength;
      this.isEanDisabled = false;
      this.eanPlaceholder = `Digite o código ${selectedType.label}`;
      
      // Clear the EAN field when type changes
      const eanControl = this.productBasicDataService.form.get('embalagemUnitaria.ean');
      eanControl.setValue('');
      eanControl.enable();
      
      // Force update the form control
      eanControl.updateValueAndValidity();
    } else {
      this.isEanDisabled = true;
      this.eanMask = '';
      this.eanMaxLength = 0;
      this.eanPlaceholder = 'Selecione o tipo primeiro';
      
      // Disable the EAN field when no type is selected
      const eanControl = this.productBasicDataService.form.get('embalagemUnitaria.ean');
      eanControl.setValue('');
      eanControl.disable();
    }
  }
}
